import { render } from "./liveboard.svg?vue&type=template&id=6f8353f6"
const script = {}
script.render = render

export default script